const API = "/api/almacen";

/**
 * Obtiene el inventario completo para administración
 * Incluye: stock, precio_compra y fecha_vencimiento
 */
export const getInventario = async () => {
    const response = await fetch(API);
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al obtener el inventario");
    }
    return await response.json();
};

/**
 * Guarda o actualiza un producto desde el Almacén
 * @param {Object} item - Objeto con los datos del producto
 */
export const saveItemAlmacen = async (item) => {
    const response = await fetch(API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(item),
    });
    
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al procesar el producto en almacén");
    }
    return await response.json();
};

/**
 * Realiza un borrado lógico del producto
 * @param {number|string} id - ID del producto a ocultar
 */
export const deleteItemAlmacen = async (id) => {
    const response = await fetch(`${API}?id=${id}`, {
        method: "DELETE",
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al eliminar el item");
    }
    return true;
};